import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from '../../shared';
import { BlogPage } from  '../blog-page';

@Component({
  selector: 'linescape-website-new-look',
  template: require('./linescape-website-new-look.component.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-website-new-look.component.scss')]
})
export class LinescapeWebsiteNewLookComponent extends BlogPage {
  title = "Linescape website gets a new look and more features - Linescape";
  description = "Leading Sailing Schedule data provider refreshes its website for easier use and more targeted information.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-website-new-look/linescape-website-new-look.component.ts